import { UseGqlMutationCallbacks, useMutationWithInvalidation } from '@alice-financial/api'
import { useCurrentUserQuery } from '../queries/currentUser_gen'
import {
  SetLanguagePreferenceMutation,
  SetLanguagePreferenceMutationVariables,
  useSetLanguagePreferenceMutation,
} from './setLanguagePreference_gen'
export { LanguagePreference } from '../../generated.types'

type UseSetLanguagePreferenceOptions = UseGqlMutationCallbacks<
  SetLanguagePreferenceMutation,
  SetLanguagePreferenceMutationVariables
>

export const useSetLanguagePreference = (mutationOptions?: UseSetLanguagePreferenceOptions) => {
  const { mutateAsync: setLanguagePreference } = useSetLanguagePreferenceMutation()
  return useMutationWithInvalidation(setLanguagePreference, mutationOptions, [useCurrentUserQuery.getKey()])
}
